import { AvailableLanguage } from './../../../@core/utils/language.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { I18nService } from '../../../@core/utils';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-language-selection',
  styleUrls: ['./language-selection.component.scss'],
  templateUrl: './language-selection.component.html',
  standalone: true,
  imports: [NgClass],
})
export class LanguageSelectionComponent implements OnInit, OnDestroy {

  private subscriptions: Subscription[] = [];
  public languages: { display: string, code: AvailableLanguage }[] = [
    { display: 'FR', code: 'fr' },
    { display: 'EN', code: 'en' },
    { display: 'ES', code: 'es' },
    { display: 'PL', code: 'pl' },
  ]

  public selectedLanguage = 'en';

  constructor(
    private i18n: I18nService,
  ) { }

  public ngOnInit(): void {
    this.subscriptions.push(
      this.i18n.language$.pipe(
        filter((language) => language !== this.selectedLanguage),
      ).subscribe((language) => {
        this.selectedLanguage = language;
      }),
    );
  }

  public changeLanguage(language: AvailableLanguage): void {
    this.i18n.setLanguage(language);
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
